/**
 * Shared GraphQL operation strings for the Social Proof AppSync API.
 *
 * Single source of truth for field selections and named operations.
 * Derived from schema.graphql — update here when the schema changes.
 */

/** Selection set for TransactionItem fields */
const transactionItemFields = `
  beneficiaryBirthday
  beneficiaryCenterId
  beneficiaryCountry
  beneOrCustomId
  fcpId
  beneficiaryGlobalId
  beneficiaryImageUrl
  beneficiaryName
  cartItemGroup
  cmsId
  currentRate
  frequency
  fundCode
  interventionGlobalId
  paymentPlanCreated
  quantity`;

/** Selection set for TransactionData fields (used by mutations, subscriptions, and queries) */
export const transactionDataFields = `
  analyticsClientId
  cartId
  firstName
  isBlacklisted
  items {${transactionItemFields}
  }
  paymentType
  referrer
  sourceCode
  sourceCodePremium
  state
  supporterGlobalId
  time
  transactionId`;

/** Selection set for TransactionConnection (paginated query results) */
export const transactionConnectionFields = `
  items {${transactionDataFields}
  }
  nextToken`;

/** PublishTransaction mutation — used by the notify Lambda to push to AppSync */
export const publishTransactionMutation = `
  mutation PublishTransaction($input: PublishTransactionInput!) {
    publishTransaction(input: $input) {${transactionDataFields}
    }
  }
`;
